import { hasIntersect } from '@common/js/common'
import home from '@/page/home'
import snapshot from '@/page/snapshot'
import layout from '../layout'
import login from '@/page/index/login'
import affLogin from '@/page/index/affLogin'
import register from '@/page/index/register'
import createSmartlink from '@/page/smartlink/createSmartLink'
import smartlink from '@/page/smartlink/smartlink'
import creative from '@/page/offers/creative'
import euler from '@/page/track/offerDetect'
import myAccount from '@/page/account/myaccount'
import personnalInfo from '@/page/account/personnalInfo'
import payment from '@/page/account/payment'
import support from '@/page/support/support'
import userVerify from '@/page/account/userVerify'
import tokenInvalid from '@/page/account/tokenInvalid'

const resetPsw = () =>
  import(/* webpackChunkName: "resetPsw" */ '@/page/account/resetPsw').catch(() => {})
const offers = () => import(/* webpackChunkName: "offers" */ '@/page/offers/offers').catch(() => {})
// const topOffer = () =>
// import(/* webpackChunkName: "offers" */ '@/page/offers/topOffer').catch(() => {})
const smlTrending = () =>
  import(/* webpackChunkName: "offers" */ '@/page/smartlink/trending').catch(() => {})
// const myAccount = () => import(/* webpackChunkName: "account" */ '@/page/account/myaccount').catch(() => {})
// const payment = () => import(/* webpackChunkName: "account" */ '@/page/account/payment').catch(() => {})
const website = () =>
  import(/* webpackChunkName: "website" */ '@/page/offers/website').catch(() => {})
const creativeAudit = () =>
  import(/* webpackChunkName: "website" */ '@/page/media/creativeAudit').catch(() => {})
const Channel = () =>
  import(/* webpackChunkName: "channel" */ '@/page/channel/channel').catch(() => {})
const channelDetail = () =>
  import(/* webpackChunkName: "channelDetail" */ '@/page/channel/channelDetail').catch(() => {})
const postbackTest = () =>
  import(/* webpackChunkName: "channel" */ '@/page/channel/postbackTest').catch(() => {})
const reportApi = () =>
  import(/* webpackChunkName: "report" */ '@/page/report/reportApi').catch(() => {})
const Report = () => import(/* webpackChunkName: "report" */ '@/page/report/report').catch(() => {})
// const Sweepstake = () =>
//   import(/* webpackChunkName: "sweepstake" */ '@/page/offers/sweepstake').catch(() => {})
const specialPromotion = () =>
  import(
    /* webpackChunkName: "specialPromotion" */ '@/page/offers/specialPromotion'
  ).catch(() => {})
// const creative = () =>
//   import(/* webpackChunkName: "sweepstake" */ '@/page/offers/creative').catch(() => {})

const Commission = () =>
  import(/* webpackChunkName: "commission" */ '@/page/account/commission').catch(() => {})

const channelOfferwall = () =>
  import(
    /* webpackChunkName: "channelOfferwall" */ '@/page/channel/channelOfferwall'
  ).catch(() => {})

const helpReportApi = () =>
  import(/* webpackChunkName: "helpReportApi" */ '@/page/helpCenter/helpReportApi').catch(() => {})

// TODO remove
const DASHBOARD = 'DASHBOARD'
const OFFERS = 'OFFERS'
const REPORTS = 'REPORTS'
const MEDIA = 'MEDIA'
const ACCOUNT = 'ACCOUNT'
const SMARTLINK = 'SMARTLINK'
const TOOLS = 'TOOLS'
const HELPCENTER = 'HELPCENTER'

// TODO 统一一份配置生成
let firstMenus = [
  {
    t: 'Snapshot',
    i: 'ym_snapshot',
    children: false,
    key: DASHBOARD,
    permList: ['view_snapshot'],
    u: '/snapshot',
  },
  {
    t: 'Offers',
    i: 'ym_offers',
    children: true,
    key: OFFERS,
  },
  // {
  //   t: 'SmartLink',
  //   i: 'ym_smartlink',
  //   children: true,
  //   key: SMARTLINK,
  // },
  {
    t: 'Media',
    u: '/channel',
    i: 'ym_offers',
    children: true,
    key: MEDIA,
  },
  {
    t: 'Reports',
    i: 'ym_reports',
    children: true,
    key: REPORTS,
  },
  {
    t: 'Account',
    i: 'ym_account',
    children: true,
    key: ACCOUNT,
  },
  {
    t: 'Help Center',
    i: 'question',
    children: true,
    key: HELPCENTER,
  },
  {
    t: 'Tools',
    i: 'target',
    children: true,
    key: TOOLS,
  },
  {
    t: 'Special Promotion',
    u: '/special',
    i: 'ym_promotion',
    children: false,
    permList: ['view_special'],
  },
  {
    t: 'Apps/Platform',
    u: '/channel',
    i: 'apps_platform',
    children: false,
    permList: ['view_channel'],
  },
]

let routes = [
  {
    path: '/account',
    name: 'account-home',
    component: home,
    children: [],
  },
  {
    path: '/aff-login',
    name: 'aff-login',
    component: affLogin,
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/register',
    name: 'register',
    component: register,
  },
  {
    path: '/reset-psw',
    name: 'reset-psw',
    component: resetPsw,
  },
  {
    path: '/user-verify',
    name: 'user-verify',
    component: userVerify,
  },
  {
    path: '/token-invalid',
    name: 'token-invalid',
    component: tokenInvalid,
  },
  {
    path: '/',
    name: 'home',
    component: layout,
    redirect: { name: 'snapshot' },
    children: [
      {
        path: 'snapshot',
        name: 'snapshot',
        component: snapshot,
        meta: {
          title: 'Snapshot',
          permList: ['view_snapshot'],
        },
      },
      {
        path: 'offers/my',
        name: 'myoffers',
        component: offers,
        menu: OFFERS,
        meta: {
          title: 'Offer List',
          permList: ['view_offers'],
          type: 'own',
        },
      },
      // {
      //   path: 'offers/top',
      //   name: 'topoffers',
      //   component: topOffer,
      //   menu: OFFERS,
      //   meta: {
      //     title: 'Top Offer',
      //     permList: ['view_top_offers'],
      //   },
      // },
      {
        path: 'offers/creative/:offer_id',
        name: 'offers-creative',
        component: creative,
        meta: {
          title: 'Get Creative',
          permList: ['view_offers'],
        },
      },
      {
        path: 'offers/sml-creative/:offer_id',
        name: 'sml-creative',
        component: creative,
        meta: {
          title: 'Get Creative',
          permList: ['view_offers'],
        },
      },
      // 业务需求，暂时隐藏sweepstake offer
      // {
      //   path: 'sweepstake',
      //   name: 'sweepstake',
      //   component: Sweepstake,
      //   menu: OFFERS,
      //   meta: {
      //     title: 'Sweepstake Offer List',
      //     permList: ['view_sweepstake'],
      //   },
      // },
      {
        path: 'media/website',
        name: 'website',
        component: website,
        menu: MEDIA,
        meta: {
          title: 'My Website',
          type: '',
          permList: ['view_website'],
        },
      },
      {
        path: 'media/creative',
        name: 'creative',
        component: creativeAudit,
        menu: MEDIA,
        meta: {
          title: 'Creative Audit',
          type: '',
          permList: ['view_creative_audit'],
        },
      },
      // {
      //   path: 'smartlink/create/:sml_id',
      //   name: 'create smartlink',
      //   menu: SMARTLINK,
      //   component: createSmartlink,
      //   meta: {
      //     title: 'Create Smartlink',
      //     permList: ['view_trending'],
      //   },
      // },
      // {
      //   path: 'smartlink',
      //   name: 'smartlink',
      //   component: smartlink,
      //   menu: SMARTLINK,
      //   meta: {
      //     title: 'SmartLink List',
      //     permList: ['view_trending'],
      //   },
      // },
      // {
      //   path: 'sml-trending',
      //   name: 'sml-trending',
      //   component: smlTrending,
      //   menu: SMARTLINK,
      //   meta: {
      //     title: 'SmartLink Trending',
      //     permList: ['view_trending'],
      //   },
      // },
      // {
      //   path: 'smartlink/edit/:sml_id',
      //   name: 'edit smartlink',
      //   component: createSmartlink,
      //   meta: {
      //     title: 'Edit Smartlink',
      //     permList: ['view_trending'],
      //   },
      // },
      {
        path: 'channel',
        name: 'channel',
        component: Channel,
        // menu: TOOLS,
        meta: {
          title: 'Postback Setting',
          permList: ['view_channel'],
        },
      },
      {
        path: 'channel/create',
        name: 'channelDetail',
        component: channelDetail,
        meta: {
          title: 'Apps/Platform Setting', // Channel Setting
          permList: ['view_channel'],
        },
      },
      {
        path: 'channel/offerwall',
        name: 'channelOfferwall',
        component: channelOfferwall,
        meta: {
          title: 'Offerwall Setting',
          permList: ['view_channel'],
        },
      },
      {
        path: 'publisher-test',
        name: 'publisher-test',
        component: postbackTest,
        menu: TOOLS,
        meta: {
          title: 'Postback Test',
          permList: ['view_publisher_test'],
        },
      },
      {
        path: 'tracker',
        name: 'euler',
        component: euler,
        menu: TOOLS,
        meta: {
          title: 'Offer Detect',
          permList: ['view_tracker'],
        },
      },
      {
        path: 'creative',
        name: 'tools-creative',
        component: creative,
        menu: TOOLS,
        meta: {
          title: 'Creative',
          permList: ['view_offers'],
        },
      },
      {
        path: 'report',
        name: 'report',
        component: Report,
        meta: {
          permList: false,
        },
      },
      {
        path: 'report',
        name: 'sml_report',
        menu: SMARTLINK,
        component: Report,
        meta: {
          query: '?report=sml_report',
          title: 'SmartLink Report',
          permList: ['view_sml_report'],
        },
      },
      {
        path: 'report',
        name: 'offer_report',
        menu: OFFERS,
        component: Report,
        meta: {
          query: '?report=stat_report',
          title: 'Offer Report',
          permList: ['view_offer_report'],
        },
      },
      {
        path: 'report',
        name: 'cov_report',
        menu: OFFERS,
        component: Report,
        meta: {
          query: '?report=cov_report',
          title: 'Conversion Report',
          permList: ['view_cov_report'],
        },
      },
      {
        path: 'report',
        name: 'sdk_report',
        menu: OFFERS,
        component: Report,
        meta: {
          query: '?report=sdk_offer_wall_report',
          title: 'OfferWall Report',
          permList: ['view_sdk_report'],
        },
      },
      {
        path: 'report',
        name: 'sdk_user_point_report',
        menu: OFFERS,
        component: Report,
        meta: {
          query: '?report=sdk_user_point_report',
          title: 'User Benefit Report',
          permList: ['view_sdk_user_point_report'],
        },
      },
      {
        path: 'report',
        name: 'js_report',
        menu: REPORTS,
        component: Report,
        meta: {
          query: '?report=js_report',
          title: 'Revenue Report',
          permList: ['view_js_report'],
        },
      },
      {
        path: 'report-api',
        name: 'report-api',
        component: reportApi,
        menu: REPORTS,
        meta: {
          title: 'Report API',
          permList: ['view_report_api'],
        },
      },
      {
        path: 'report',
        name: 'interactive_report',
        menu: REPORTS,
        component: Report,
        meta: {
          query: '?report=interactive_report',
          title: 'InteractiveAds Report',
          permList: ['view_interactive_report'],
        },
      },
      {
        path: 'my-account',
        name: 'my-account',
        menu: ACCOUNT,
        component: myAccount,
        meta: {
          title: 'My Account',
          permList: ['view_account'],
        },
      },
      {
        path: 'commission',
        name: 'commission',
        component: Commission,
        meta: {
          title: 'Commission',
          permList: ['view_account'],
        },
      },
      {
        path: 'payment',
        name: 'payment',
        menu: ACCOUNT,
        component: payment,
        meta: {
          title: 'Payment',
          permList: ['view_payment'],
        },
      },
      {
        path: 'personal-info',
        name: 'personal-info',
        component: personnalInfo,
        meta: {
          title: 'Personal Infomation',
          permList: ['view_personal_info'],
        },
      },
      {
        path: 'special',
        name: 'special',
        component: specialPromotion,
        meta: {
          title: 'Special Promotion',
          permList: ['view_special'],
        },
      },
      {
        path: 'support',
        name: 'support',
        component: support,
        meta: {
          title: 'FAQ',
          permList: ['view_support'],
        },
      },
      {
        path: 'help-report-api',
        name: 'help-report-api',
        component: helpReportApi,
        menu: HELPCENTER,
        meta: {
          title: 'Report API',
          permList: ['view_help_report_api'],
        },
      },
    ],
  },
]

let secondMenus = {}
for (let item of firstMenus) {
  if (item.children) {
    secondMenus[item.key] = [] // 二级菜单初始化
  }
}

for (let i in routes) {
  let route = routes[i]
  if (route.menu && secondMenus[route.menu]) {
    // 一级路由是否属于菜单项
    secondMenus[route.menu].push({
      t: route.meta.title,
      u: route.path,
      permList: route.meta.permList,
    })
  } else if (route.children) {
    let parentPath = route.path === '/' ? '' : route.path
    let children = route.children
    for (let k in children) {
      // 遍历嵌套路由 看是否属于菜单项
      let child = children[k]
      let query_url = ''
      if (child.meta) {
        query_url = child.meta.query ? child.meta.query : ''
      }
      if (child.menu && secondMenus[child.menu]) {
        secondMenus[child.menu].push({
          t: child.meta.title,
          u: parentPath + '/' + child.path + query_url,
          permList: child.meta.permList,
        })
      }
    }
  }
}

/**
 * 生成菜单对象
 * @permList 用户权限列表
 * @isSuperuser 是否管理员
 */
function generateMenu(permList, isSuperuser) {
  function hasPerm(perms) {
    return perms === false ? true : hasIntersect(perms, permList)
  }

  function resolveSecondMenus(menus) {
    let arr = []
    menus = secondMenus[menus]
    for (let menu of menus) {
      if (isSuperuser || hasPerm(menu.permList)) {
        arr.push({ t: menu.t, u: menu.u })
      }
    }
    return arr
  }

  function resolveFirstMenus(menus) {
    let arr = []
    for (let menu of menus) {
      if (menu.children) {
        // 一级目录存在子目录
        arr.push({ t: menu.t, i: menu.i, ul: resolveSecondMenus(menu.key) })
      } else if (isSuperuser || hasPerm(menu.permList)) {
        // 一级目录即为跳转项
        arr.push({ t: menu.t, i: menu.i, u: menu.u })
      }
    }
    return arr
  }

  let menu = resolveFirstMenus(firstMenus).filter(m => {
    return m.u || m.ul.length
  })
  return menu
}

export { generateMenu, routes }
